<template>
  <div class="my-profile">
      <ContentHeader :name="viewName"></ContentHeader>
      <section>
        <div class="d-lg-flex justify-content-between text-center pt-2 mb-3">
          <ul class="list-group">
            <li class="list-group-item userProfilePic">
              <img class="rounded-circle" :src="userDetails.profilePic" alt="Default profile">
            </li>
            <li v-if="$route.name !== 'Profile' && isIrdeto" class="list-group-item"><button class="btn btn-link p-0" v-on:click="showEditMode = !showEditMode">{{editText}}</button></li>
            <li class="list-group-item">Current profile picture</li>
          </ul>
          <div class="text-lg-left my-3 px-2">
            <h4>{{userDetails.name}}</h4>
            <h6><span class="text-black-50"><i class="fas fa-list-ol fa-fw"></i> Staff no.</span>
              <span v-if="userDetails.employeeNumber == 0">Contractor</span>
              <span v-if="userDetails.employeeNumber != 0">{{userDetails.employeeNumber}}</span>
            </h6>
            <!--h6>
              <span class="text-black-50"><i class="fas fa-user-friends fa-fw"></i> Communities:</span>
              <div class="community-categories">
                <a v-for="(community, index) in userDetails.communities" v-bind:key="'com' + index" :href="'/#/communities/community/' + community.slug">{{community.name}}</a>
              </div>
            </h6-->
            <h6><span class="text-black-50"><i class="fas fa-building fa-fw"></i> Company:</span> {{userDetails.department}}</h6>
            <h6><span class="text-black-50"><i class="fas fa-globe fa-fw"></i> Country:</span> {{userDetails.country}}</h6>
            <!--h6><span class="text-black-50"><i class="fas fa-coins fa-fw"></i> My coins:</span> {{totalGraduated * 5}} <span class="text-black-50">(10 coins = free <i class="fas fa-coffee fa-fw fa-sm"></i> from Vida) </span></h6-->
            <h6><span class="text-black-50"><i class="fas fa-star fa-fw"></i> Graduated ideas:</span> {{totalGraduated}}</h6>
          </div>
          <ul class="list-group">
            <!--li class="list-group-item"><img src="static/lego-character.png" width="99" height="150" alt="Lego character"></li>
            <li class="list-group-item"><router-link to="/digital-store">Update your <br>lego character</router-link></li-->
          </ul>
        </div>
      </section>
      <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError" v-if="!showEditMode && $route.name !== 'Profile'"></PreContentHeader>
      <transition name="grow" v-if="!showEditMode && $route.name !== 'Profile'">
        <div v-if="contentReady && contentLoadError === ''">
          <section class="userActivityFeed">
            <b-card no-body>
              <b-tabs card>
                <b-tab>
                  <template slot="title">
                    <i class="fas fa-trophy fa-fw"></i> <span>Ideas</span>
                  </template>
                  <ProfileTabContent :error-message="childContentLoadError">
                    <Loading v-if="!showIdeas"></Loading>
                    <Ideas v-if="showIdeas && ideas.length > 0" :ideas="ideas"></Ideas>
                    <span v-if="showIdeas && ideas.length === 0">There are no submitted ideas, <router-link to="/idea-challenges">view the Idea Challenges here</router-link> and submit an idea</span>
                  </ProfileTabContent>
                  <div class="row" v-if="showIdeas && ideas.length > 0">
                    <div class="col-sm-6 mt-3">
                      <b-pagination v-on:click="loadIdeas()" size="md" :total-rows="totalPosts" v-model="currentPageIdeas" :per-page="itemsPerPage"></b-pagination>
                    </div>
                    <div class="col-sm-6 mt-3">
                      <div class="items-per-page">
                        <label for="itemsPerPage">Items per page: </label>
                        <select v-model="itemsPerPage" id="itemsPerPage" v-on:change="loadIdeas()" class="form-control">
                          <option :value="10">10</option>
                          <option :value="25">25</option>
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab @click="loadComments()">
                  <template slot="title">
                    <i class="fas fa-comments fa-fw"></i> <span>Comments</span>
                  </template>
                  <ProfileTabContent :error-message="childContentLoadError">
                    <Loading v-if="!showComments"></Loading>
                    <Comments v-if="showComments && comments[0].length > 0" :comments="comments" :show-post="true" ignore-nesting="true"></Comments>
                    <span v-if="showComments && comments[0].length === 0">There are no submitted comments</span>
                  </ProfileTabContent>
                  <div class="row" v-if="showComments && comments[0].length > 0">
                    <div class="col-sm-6 mt-3">
                      <b-pagination v-on:click="loadComments()" size="md" :total-rows="totalPosts" v-model="currentPageComments" :per-page="itemsPerPage"></b-pagination>
                    </div>
                    <div class="col-sm-6 mt-3">
                      <div class="items-per-page">
                        <label for="itemsPerPage">Items per page: </label>
                        <select v-model="itemsPerPage" id="itemsPerPage" v-on:change="loadComments()" class="form-control">
                          <option :value="10">10</option>
                          <option :value="25">25</option>
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab @click="loadLikes()">
                  <template slot="title">
                    <i class="fas fa-thumbs-up fa-fw"></i> <span>Likes</span>
                  </template>
                  <ProfileTabContent :error-message="childContentLoadError">
                    <Loading v-if="!showLikes"></Loading>
                    <Likes v-if="showLikes && likes.length > 0" :likes="likes"></Likes>
                    <span v-if="showLikes && likes.length === 0">There are no liked any ideas</span>
                  </ProfileTabContent>
                  <div class="row" v-if="showLikes && likes.length > 0">
                    <div class="col-sm-6 mt-3">
                      <b-pagination v-on:click="loadLikes()" size="md" :total-rows="totalPosts" v-model="currentPageLikes" :per-page="itemsPerPage"></b-pagination>
                    </div>
                    <div class="col-sm-6 mt-3">
                      <div class="items-per-page">
                        <label for="itemsPerPage">Items per page: </label>
                        <select v-model="itemsPerPage" id="itemsPerPage" v-on:change="loadLikes()" class="form-control">
                          <option :value="10">10</option>
                          <option :value="25">25</option>
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab @click="loadFollows()">
                  <template slot="title">
                    <i class="fas fa-lightbulb fa-fw"></i> <span>Follows</span>
                  </template>
                  <ProfileTabContent :error-message="childContentLoadError">
                    <Loading v-if="!showFollows"></Loading>
                    <Ideas v-if="showFollows && follows.length > 0" :ideas="follows"></Ideas>
                    <span v-if="showFollows && follows.length === 0">There are no followed ideas</span>
                  </ProfileTabContent>
                  <div class="row" v-if="showFollows && follows.length > 0">
                    <div class="col-sm-6 mt-3">
                      <b-pagination v-on:click="loadFollows()" size="md" :total-rows="totalPosts" v-model="currentPageFollows" :per-page="itemsPerPage"></b-pagination>
                    </div>
                    <div class="col-sm-6 mt-3">
                      <div class="items-per-page">
                        <label for="itemsPerPage">Items per page: </label>
                        <select v-model="itemsPerPage" id="itemsPerPage" v-on:change="loadFollows()" class="form-control">
                          <option :value="10">10</option>
                          <option :value="25">25</option>
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab @click="loadMakeMark()">
                  <template slot="title">
                    <i class="fas fa-quote-left fa-fw"></i> <span>Innovation Always Onsite</span>
                  </template>
                  <ProfileTabContent :error-message="childContentLoadError">
                    <Loading v-if="!showMakeMark"></Loading>
                    <Ideas v-if="showMakeMark && makeMarks.length > 0" :ideas="makeMarks"></Ideas>
                    <span v-if="showMakeMark && makeMarks.length === 0">There are no ideas, visit <a href="/#/innovation-always-on-site">Innovation Always On Site</a> and submit an idea</span>
                  </ProfileTabContent>
                  <div class="row" v-if="showMakeMark && makeMarks.length > 0">
                    <div class="col-sm-6 mt-3">
                      <b-pagination v-on:click="loadMakeMark()" size="md" :total-rows="totalPosts" v-model="currentPageMakeMarks" :per-page="itemsPerPage"></b-pagination>
                    </div>
                    <div class="col-sm-6 mt-3">
                      <div class="items-per-page">
                        <label for="itemsPerPage">Items per page: </label>
                        <select v-model="itemsPerPage" id="itemsPerPage" v-on:change="loadMakeMark()" class="form-control">
                          <option :value="10">10</option>
                          <option :value="25">25</option>
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab @click="loadNominationsReceived()">
                  <template slot="title">
                    <i class="fas fa-sign-in-alt fa-fw"></i> <span><strong>Nomination:</strong> received</span>
                  </template>
                  <ProfileTabContent :error-message="childContentLoadError">
                    <Loading v-if="!showReceivedNominations" loading-message="Looking for your nominations, it might take longer. Please wait"></Loading>
                    <Nominations v-if="receivedNominations.length > 0" :nominations="receivedNominations" type="received"></Nominations>
                    <span v-if="showReceivedNominations && receivedNominations.length === 0">There are no received nominations</span>
                  </ProfileTabContent>
                </b-tab>
                <b-tab @click="loadNominationsSent()">
                  <template slot="title">
                    <i class="fas fa-sign-out-alt fa-fw"></i> <span><strong>Nomination:</strong> sent</span>
                  </template>
                  <ProfileTabContent :error-message="childContentLoadError">
                    <Loading v-if="!showSentNominations"></Loading>
                    <Nominations v-if="showSentNominations && sentNominations.length > 0" :nominations="sentNominations" type="sent"></Nominations>
                    <span v-if="showSentNominations && sentNominations.length === 0">There are no nominations. <router-link to="/recognition">Nominate a co-worker here</router-link></span>
                  </ProfileTabContent>
                </b-tab>
                <b-tab active @click="loadNominationsforReview()">
                  <template slot="title">
                    <i class="fas fa-sign-out-alt fa-fw"></i> <span><strong>Nomination:</strong> Review</span>
                  </template>
                  <ProfileTabContent :error-message="childContentLoadError">
                    <Loading v-if="!showReviewdNominations"loading-message="Looking for nominations to review, it might take longer. Please wait"></Loading>
                    <ReviewNominations v-if="reviewdNominations.length > 0" :exportNomination="nominations[0]" :nominations="reviewdNominations" type="review" :userDetails="userDetails.email" :userEmail="userDetails.username"></ReviewNominations>
                    <span v-if="showReviewdNominations && reviewdNominations.length === 0">There are no nominations for your review. Please feel free to, <router-link to="/recognition">Nominate a co-worker here</router-link></span>
                  </ProfileTabContent>
                </b-tab>
                <b-tab @click="loadNominationsforHRBP()">
                  <template slot="title">
                    <i class="fas fa-sign-out-alt fa-fw"></i> <span><strong>Nomination:</strong> HCBP</span>
                  </template>
                  <ProfileTabContent :error-message="childContentLoadError">
                    <Loading v-if="!showHRBPNominations" loading-message="Looking for your nomination as HCBP, it might take longer. Please wait"></Loading>
                    <ReviewNominations v-if="hrbpNominations.length > 0"  :exportNomination="nominations[0]" :nominations="hrbpNominations" type="hrbp" :userDetails="userDetails.email" :userEmail="userDetails.username"></ReviewNominations>
                    <span v-if="showHRBPNominations && hrbpNominations.length === 0">There are no nominations for your review. Please feel free to, <router-link to="/recognition">Nominate a co-worker here</router-link></span>
                  </ProfileTabContent>
                </b-tab>
                <b-tab @click="loadNominationsOfTheMonth()">
                  <template slot="title">
                    <i class="fas fa-sign-out-alt fa-fw"></i> <span><strong>Nomination:</strong> Employee Awards</span>
                  </template>
                  <ProfileTabContent :error-message="childContentLoadError">
                    <Loading v-if="!showMonthNominations" loading-message="Looking for nominations to view, it might take longer. Please wait"></Loading>
                    <ReviewNominations v-if="monthNominations.length > 0 && userDetails.username == ''" :exportNomination="nominations[0]" :nominations="monthNominations" type="EmployeeAward" :userDetails="userDetails.email" :userEmail="userDetails.email"></ReviewNominations>
                    <ReviewNominations v-if="monthNominations.length > 0 && userDetails.username != ''" :exportNomination="nominations[0]" :nominations="monthNominations" type="EmployeeAward" :userDetails="userDetails.email" :userEmail="userDetails.username"></ReviewNominations>
                    <span v-if="showMonthNominations && monthNominations.length === 0">There are no nominations for your review. Please feel free to, <router-link to="/recognition">Nominate a co-worker here</router-link></span>
                  </ProfileTabContent>
                </b-tab>    
                <b-tab @click="loadGraduatedIdeas()">
                  <template slot="title">
                    <i class="fas fa-star fa-fw"></i> <span>Graduated</span>
                  </template>
                  <ProfileTabContent :error-message="childContentLoadError">
                    <Loading v-if="!showGraduatedIdeas"></Loading>
                    <Ideas v-if="showGraduatedIdeas && graduatedIdeas.length > 0" :ideas="graduatedIdeas"></Ideas>
                    <span v-if="showGraduatedIdeas && graduatedIdeas.length === 0">There are no graduated ideas. You can submit new ideas for an <router-link :to="'/idea-challenges'">idea challenge here</router-link></span>
                  </ProfileTabContent>
                </b-tab>
              </b-tabs>
            </b-card>
          </section>
        </div>
      </transition>
      <template v-if="showEditMode">
        <section class='entry-content'>
          <div class="list-group mb-3">
            <div class="list-group-item d-md-flex">
              <img class="border mb-1" src="https://thinktankapi.multichoice.com/wp-content/themes/blankslate/images/password-icon.svg" width="100" height="100">
              <div class="ml-md-4">
                <h5>Change password</h5>
                <small class="text-black-50">Change your login password</small>
                <div class="input-group" v-if="isIrdeto">
                  <input v-model="userPassword" type="password" placeholder="Enter New Password..." required="required" class="form-control">
                  <div class="input-group-append">
                    <button type="submit" class="btn btn-primary" :disabled="!activateChangePasswordButton" v-on:click="updatePassword()">Change password</button>
                  </div>
                </div>
                <div v-if="passwordChangeStatus.show" class="alert alert-success mt-2" role="alert">
                  Your password has been updated
                </div>
              </div>
            </div>
          </div>
          <div class="list-group mb-3">
            <div class="list-group-item d-md-flex">
              <img class="border mb-1" :src="profileImageSrc" width="100" height="100">
              <div class="ml-md-4">
                <h5>Update profile picture</h5>
                <div class="form-group">
                  <small class="text-black-50">File formats accepted: jpg, jpeg, png</small>
                  <input type="file" class="form-control-file pt-1" id="file" ref="file" v-on:change="activateUploadButtonMethod()">
                </div>
                <button type="button" id="" class="btn btn-primary" :disabled="!activateUploadButton" v-on:click="postProfileImage()">Update profile picture</button>
                <div v-if="ImageUploaded" class="alert mt-2" v-bind:class="[ImageClass]" role="alert" v-html="ImageUploadMsg"></div>
                <hr>
                <p>If you'd prefer to use your <strong>Lego character</strong> as your profile picture, <a class="font-weight-bold" href="/#/my-profile/edit-my-details/#">update here �</a></p>
              </div>
            </div>
          </div>
          <p class="text-center h6">Should you require assistance, please email: <a href="mailto:ThinkTank@multichoice.co.za">ThinkTank@multichoice.co.za</a></p>
        </section>
      </template>
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import ContentHeader from '@/components/ContentHeader'
import Ideas from '@/components/Ideas'
import Comments from '@/components/Comments'
import Likes from '@/components/Likes'
import Loading from '@/components/Loading'
import Nominations from '@/components/Nominations'
import ReviewNominations from '@/components/ReviewNominations'
import ProfileTabContent from '@/components/ProfileTabContent'
import {BCard, BTabs, BTab, BPagination} from 'bootstrap-vue'
import PreContentHeader from '@/components/PreContentHeader'
export default {
  components: {
    PreContentHeader,
    'b-card': BCard,
    'b-tabs': BTabs,
    'b-tab': BTab,
    'b-pagination': BPagination,
    ContentHeader,
    Ideas,
    Comments,
    Likes,
    Loading,
    Nominations,
    ReviewNominations,
    ProfileTabContent
  },
  props: [
    'userDetails',
    'viewName',
    'showEditMode'
  ],
  data () {
    return {
      contentLoadError: '',
      contentReady: false,
      ideas: [],
      showIdeas: false,
      comments: [],
      showComments: false,
      likes: [],
      showLikes: false,
      follows: [],
      showFollows: false,
      makeMarks: [],
      showMakeMark: false,
      nominations: [],
      rcvdNominations: [],
      sentNominations: [],
      showSentNominations: false,
      receivedNominations: [],
      reviewdNominations: [],
      hrbpNominations: [],
      monthNominations: [],
      showReceivedNominations: false,
      showReviewdNominations: false,
      showHRBPNominations: false,
      showMonthNominations: false,
      graduatedIdeas: [],
      showGraduatedIdeas: false,
      isAdmin: false,
      childContentLoadError: '',
      currentPageIdeas: 1,
      currentPageComments: 1,
      currentPageLikes: 1,
      currentPageFollows: 1,
      currentPageMakeMarks: 1,
      totalPosts: 0,
      itemsPerPage: 10,
      totalGraduated: 0,
      userPassword: '**********',
      activateUploadButton: false,
      profileImage: '',
      imageData: 'https://thinktankapi.multichoice.com/wp-content/themes/blankslate/images/profile-icon.svg',
      ImageUploadMsg: '',
      ImageUploaded: false,
      ImageClass: '',
      isIrdeto: false,
      totalPages: 0,
      totalPagesRcvd: 0,
      passwordChangeStatus: {
        show: false
      }
    }
  },
  created () {
    this.getTotalGraduatedIdeas()
    console.log('profile UD-> ', this.userDetails)
    this.loadNominations()
    console.log(' after loadNominations called ')
    this.loadRecievedNominations()
    console.log(' after loadRecievedNominations called ')
    if (this.userDetails.email) {
      if (this.userDetails.email.indexOf('irdeto') !== -1 || this.userDetails.email.indexOf('showmax') !== -1) {
        this.isIrdeto = true
      }
    }  
  },
  watch: {
    'userDetails' (to, from) {
      this.getTotalGraduatedIdeas()
      this.loadIdeas()
      this.loadNominations()
      this.loadRecievedNominations()
    },
    'currentPageIdeas' (newDetails, oldDetails) {
      this.showIdeas = false
      this.loadIdeas()
    },
    'currentPageComments' (newDetails, oldDetails) {
      this.showComments = false
      this.loadComments()
    },
    'currentPageLikes' (newDetails, oldDetails) {
      this.showLikes = false
      this.loadLikes()
    },
    'currentPageFollows' (newDetails, oldDetails) {
      this.showFollows = false
      this.loadFollows()
    },
    'currentPageMakeMarks' (newDetails, oldDetails) {
      this.showMakeMark = false
      this.loadMakeMark()
    }
  },
  computed: {
    editText: function () {
      if (this.showEditMode) {
        return 'Stop editing'
      } else {
        return 'Edit profile'
      }
    },
    profileImageSrc: function () {
      var self = this
      self.ImageUploaded = true
      if (self.profileImage) {
        if (self.profileImage.type === 'image/png' || self.profileImage.type === 'image/jpg' || self.profileImage.type === 'image/jpeg') {
          var reader = new FileReader()
          reader.onload = (e) => {
            self.imageData = e.target.result
          }
          reader.readAsDataURL(self.profileImage)
          self.ImageUploadMsg = 'Valid Format'
          self.ImageClass = 'alert-success'
          return self.imageData
        } else {
          self.ImageUploadMsg = 'Invalid Image format'
          self.ImageClass = 'alert-danger'
          self.activateUploadButton = false
          return self.userDetails.profilePic
        }
      }
      return self.userDetails.profilePic
    },
    activateChangePasswordButton: function () {
      return this.userPassword !== '**********'
    }
  },
  methods: {
    loadNominations: function () {
      if (this.userDetails.email !== undefined && this.nominations.length === 0 && this.totalPages === 0) {
        console.log('profile UD->  this.userDetails ', this.userDetails)  
        this.totalPages = 1
        let userEmails = [this.userDetails.email.toLowerCase(), this.userDetails.username.toLowerCase()]
        WordpressRestAPI.getCustomViewContent('getNomination/v1/getUserReviewNomination?email=' + userEmails)
          .then(response => {
            console.log('review list-> ', response.data)
            if (response.data !== false) {
              let PIDs = response.data.split("&")    
              if (PIDs.length > 200) {
                for ( let t = 0; t < PIDs.length; t += 200 ) {
                  let sliceStart = t
                  let sliceEnd = t + 200
                WordpressRestAPI.getViewContent('nomination?_embed=true&custom_per_page=500&' + PIDs.slice(sliceStart, sliceEnd).join("&"))
                  .then(response => {
                    if (!this.nominations[0]) {
                      this.nominations.push(response.data)
                    } else {
                      let noms = this.nominations[0].concat(response.data)
                      this.nominations = [] //reset to combine
                      this.nominations.push(noms)
                    }
                    this.loadNominationsforReview()
                    this.loadNominationsforHRBP()
                  })
                  .catch(e => {
                    this.childContentLoadError = 'Oops! We had a problem with loading your nominations. Please try again later.'
                    console.error(e)
                  })
                }
              } else {
              WordpressRestAPI.getViewContent('nomination?_embed=true&custom_per_page=500&' + PIDs.join("&"))
                .then(response => {
                  this.nominations.push(response.data)
                  this.loadNominationsforReview()
                  this.loadNominationsforHRBP()
                })
                .catch(e => {
                  this.childContentLoadError = 'Oops! We had a problem with loading your nominations. Please try again later.'
                  console.error(e)
                })
              }
            } else {
				this.loadNominationsforReview()
			}
            this.loadIdeas()
            console.log(' end of loadNominations ')
          })
          .catch(e => {
            this.loadIdeas()
            this.childContentLoadError = 'Oops! We had a problem with loading your nominations. Please try again later.'
            console.error(e)
          })
      }
    },
    loadRecievedNominations: function () {
      if (this.userDetails.slug !== undefined && this.rcvdNominations.length === 0 && this.totalPagesRcvd === 0) {
        this.totalPagesRcvd = 1
        WordpressRestAPI.getCustomViewContent('getNomination/v1/getUserReviewNomination?slug=' + this.userDetails.slug.toLowerCase())
          .then(response => {
            console.log('recvd list-> ', response.data)
            if (response.data !== false)
            WordpressRestAPI.getViewContent('nomination?_embed=true&custom_per_page=500&' + response.data)
              .then(response => {
                this.rcvdNominations.push(response.data)
                this.loadNominationsReceived()
              })
              .catch(e => {
                this.childContentLoadError = 'Oops! We had a problem with loading your nominations. Please try again later.'
                console.error(e)
              })
          })
          .catch(e => {
            this.childContentLoadError = 'Oops! We had a problem with loading your nominations. Please try again later.'
            console.error(e)
          })
      }
    },
    loadNominationsOfTheMonth: function () {
      this.monthNominations = []
      for (var i = 0; i < this.nominations.length; i++) {
        this.childContentLoadError = ''
        for (var j = 0; j < this.nominations[i].length; j++) {
          if (this.nominations[i][j].nomination_event_category[0] === 100 || this.nominations[i][j].nomination_event_category[0] === 138 || this.nominations[i][j].nomination_event_category[0] === 141) {
            if (this.checkNominationWorkflow(this.nominations[i][j].teamnominationworkflow[0])) {
              this.monthNominations = this.monthNominations.concat(this.nominations[i][j])
            }
          }
        }
      }
      this.showMonthNominations = true
    },
    activateUploadButtonMethod: function () {
      this.activateUploadButton = true
      this.profileImage = this.$refs.file.files[0]
    },
    updatePassword: function () {
      var self = this
      WordpressRestAPI.updatePassword(self.userDetails.id, self.userPassword)
        .then(response => {
          console.log(response.data)
          self.userPassword = '**********'
          self.passwordChangeStatus = {
            message: 'Your password has been updated',
            class: 'alert-success',
            show: true
          }
        })
        .catch(e => {
          console.error(e)
          self.userPassword = '**********'
          self.passwordChangeStatus = {
            message: 'There was an error updating your password. Please try again later',
            class: 'alert-warning',
            show: true
          }
        })
    },
    addMediaToProfile: function (mediaID) {
      var self = this
      var userData = {
        method: 'POST',
        data: {
          id: self.userDetails.id,
          meta: 'thinktankProfileImage',
          value: mediaID
        },
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      WordpressRestAPI.updateThinkTankUser(userData)
        .then(function (response) {
          self.ImageUploadMsg = 'Profile Picture has been updated'
          self.ImageClass = 'alert-success'
          self.$router.go(self.$router.currentRoute)
        })
        .catch(function (e) {
          self.ImageUploadMsg = 'Error Upload Profile Picture. Please try again.'
          self.ImageClass = 'alert-danger'
          self.activateUploadButton = true
          console.error(e)
        })
    },
    postProfileImage: function () {
      this.activateUploadButton = false
      var self = this
      let formData = new FormData()
      formData.append('file', this.profileImage)
      formData.append('title', 'Profile Image for ' + this.$store.getters.getUserName)
      formData.append('caption', 'Profile Image for ' + this.$store.getters.getUserName)
      var uploadMedia = {
        method: 'POST',
        processData: false,
        contentType: false,
        data: formData,
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      WordpressRestAPI.endpointWithAuthetication(uploadMedia, 'media')
        .then(function (response) {
          self.addMediaToProfile(response.data.id)
        })
        .catch(function (e) {
          self.ImageUploadMsg = 'Error Upload Profile Picture. Please try again.'
          self.ImageClass = 'alert-danger'
          self.activateUploadButton = true
          console.error(e)
        })
    },
    getTotalGraduatedIdeas: function () {
      if (this.userDetails.id !== undefined) {
        WordpressRestAPI.getTotalGraduatedIdeas(this.userDetails.id)
          .then(response => {
            this.totalGraduated = response.data
          })
          .catch(e => {
            console.error(e)
          })
      }
    },
    loadIdeas: function () {
      if (this.userDetails.id !== undefined) {
        WordpressRestAPI.getViewContent('idea?_embed=true&author=' + this.userDetails.id + '&idea_chalenge_category_exclude=10&page=' + this.currentPageIdeas + '&per_page=' + this.itemsPerPage)
          .then(response => {
            this.totalPosts = parseInt(response.headers['x-wp-total'])
            this.childContentLoadError = ''
            this.ideas = response.data
            this.showIdeas = true
            this.contentReady = true
          })
          .catch(e => {
            this.childContentLoadError = 'Oops! We had a problem with loading your ideas. Please try again later.'
            console.error(e)
          })
      }
    },
    loadComments: function () {
      this.comments = []
      var commentsOptions = {
        method: 'GET',
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      WordpressRestAPI.endpointWithAuthetication(commentsOptions, 'comments?author=' + this.userDetails.id + '&_embed&page=' + this.currentPageComments + '&per_page=' + this.itemsPerPage)
        .then(response => {
          this.totalPosts = parseInt(response.headers['x-wp-total'])
          this.childContentLoadError = ''
          this.comments.push(response.data)
          this.showComments = true
        })
        .catch(e => {
          this.childContentLoadError = 'Oops! We had a problem with loading your comments. Please try again later.'
          console.error(e)
        })
    },
    loadLikes: function () {
      WordpressRestAPI.getViewContent('like?author=' + this.userDetails.id + '&page=' + this.currentPageLikes + '&per_page=' + this.itemsPerPage)
        .then(response => {
          this.totalPosts = parseInt(response.headers['x-wp-total'])
          this.childContentLoadError = ''
          this.likes = response.data
          this.showLikes = true
        })
        .catch(e => {
          this.childContentLoadError = 'Oops! We had a problem with loading your likes. Please try again later.'
          console.error(e)
        })
    },
    setIdeasFollowed: function (follows) {
      this.showFollows = false
      WordpressRestAPI.getViewContent('idea?include=' + follows.map(x => x.idea_post_id_follow[0]).join() + '&_embed')
        .then(response => {
          this.follows = response.data
          this.showFollows = true
        })
        .catch(e => {
          this.childContentLoadError = 'Oops! We had a problem with loading your followed ideas. Please try again later.'
          console.error(e)
        })
    },
    loadFollows: function () {
      WordpressRestAPI.getViewContent('follow?author=' + this.userDetails.id + '&page=' + this.currentPageFollows + '&per_page=' + this.itemsPerPage)
        .then(response => {
          this.totalPosts = parseInt(response.headers['x-wp-total'])
          this.childContentLoadError = ''
          if (response.data.length > 0) {
            this.setIdeasFollowed(response.data)
          } else {
            this.follows = []
            this.showFollows = true
          }
        })
        .catch(e => {
          this.childContentLoadError = 'Oops! We had a problem with loading your follows. Please try again later.'
          console.error(e)
        })
    },
    loadMakeMark: function () {
      WordpressRestAPI.getViewContent('idea?idea_chalenge_category=10&_embed=true&author=' + this.userDetails.id + '&page=' + this.currentPageFollows + '&per_page=' + this.itemsPerPage)
        .then(response => {
          this.totalPosts = parseInt(response.headers['x-wp-total'])
          this.childContentLoadError = ''
          this.makeMarks = response.data
          this.showMakeMark = true
        })
        .catch(e => {
          this.childContentLoadError = 'Oops! We had a problem with loading your make your mark ideas. Please try again later.'
          console.error(e)
        })
    },
    getNominationTeams: function (nominationteam) {
      do {
        if (nominationteam[0].length === 1) {
          nominationteam[0] = nominationteam[0][0]
        }
      } while (nominationteam[0].length === 1)
      return nominationteam
    },
    loadNominationsReceived: function () {
      this.receivedNominations = []
      for (var i = 0; i < this.rcvdNominations.length; i++) {
        this.childContentLoadError = ''
        for (var j = 0; j < this.rcvdNominations[i].length; j++) {
          if (this.rcvdNominations[i][j].isteamaward.includes('true') || this.rcvdNominations[i][j].nominationteam[0] !== null ) {
            this.rcvdNominations[i][j].nominationteam = this.getNominationTeams(this.rcvdNominations[i][j].nominationteam)
            var tempTeam = this.rcvdNominations[i][j].nominationteam[0].filter(x => x.member_slug === this.userDetails.slug)
            if (tempTeam.length > 0) {
              this.receivedNominations = this.receivedNominations.concat(this.rcvdNominations[i][j])
            }
          } else if (this.rcvdNominations[i][j].nominee_slug[0] === this.userDetails.slug) {
            this.receivedNominations = this.receivedNominations.concat(this.rcvdNominations[i][j])
          }
        }
      }
      //if (this.rcvdNominations.length > 0) {
      this.showReceivedNominations = true
      //}
    },
    loadNominationsSent: function () {
      WordpressRestAPI.getViewContent('nomination?_embed=true&author=' + this.userDetails.id + '&per_page=100')
        .then(response => {
          this.childContentLoadError = ''
          this.sentNominations = response.data
          this.showSentNominations = true
        })
        .catch(e => {
          this.childContentLoadError = 'Oops! We had a problem with loading your sent nominations. Please try again later.'
          console.error(e)
        })
    },
    loadGraduatedIdeas: function () {
      this.showGraduatedIdeas = true
      WordpressRestAPI.getViewContent('idea?idea_chalenge_category=29&_embed=true&author=' + this.userDetails.id)
        .then(response => {
          this.childContentLoadError = ''
          this.graduatedIdeas = response.data
          this.showGraduatedIdeas = true
        })
        .catch(e => {
          this.childContentLoadError = 'Oops! We had a problem with loading your graduated ideas. Please try again later.'
          console.error(e)
        })
    },
    loadNominationsforReview: function () {
      this.reviewdNominations = []
      console.log('loadNominationsforReview: loadNominationsforReview nominations ', this.nominations)
      for (var i = 0; i < this.nominations.length; i++) {
        this.childContentLoadError = ''
        for (var j = 0; j < this.nominations[i].length; j++) {
          console.log('loadNominationsforReview: 771 i', i, 'j ', j,  this.nominations[i][j].nomination_event_category[0])    
          if (this.nominations[i][j].nomination_event_category[0] !== 19 && this.nominations[i][j].nomination_event_category[0] !== 18 && this.nominations[i][j].nomination_event_category[0] !== 17 && this.nominations[i][j].nomination_event_category[0] !== 100 && this.nominations[i][j].nomination_event_category[0] !== 138 && this.nominations[i][j].nomination_event_category[0] !== 141) {
            console.log('loadNominationsforReview: 773 i', i, 'j ', j, this.nominations[i][j].nomination_approve_decline[0] &&  this.nominations[i][j].nomination_event_category[0] !== 100 && this.nominations[i][j].nomination_event_category[0] !== 138 && this.nominations[i][j].nomination_event_category[0] !== 141)
            if (this.nominations[i][j].nomination_approve_decline[0] === 'Accepted') {
              // let temp = (this.nominations[i][j].teamnominationworkflow[0].filter(d => d.project_sponsor_email.toLowerCase() === this.userDetails.email.toLowerCase() && d.project_sponsor_status === ''))
              console.log('loadNominationsforReview: 775 i', i, 'j ', j,  '775 accepted', this.nominations[i][j].teamnominationworkflow[0])

              if (this.checkNominationWorkflow(this.nominations[i][j].teamnominationworkflow[0])) {
                                  console.log('loadNominationsforReview: workflow selected')
                this.reviewdNominations = this.reviewdNominations.concat(this.nominations[i][j])
              }
            }
          }
        }
      }
      console.log('loadNominationsforReview:  this.reviewdNominations ', this.reviewdNominations,' this.reviewdNominations.length ', this.reviewdNominations.length)
      console.log('loadNominationsforReview:  this.nominations ', this.nominations)
      this.showReviewdNominations = true
      console.log('loadNominationsforReview:  798 this.showReviewdNominations ', this.showReviewdNominations)
    },
    loadNominationsforView: function () {
      this.reviewdNominations = []
      for (var i = 0; i < this.nominations.length; i++) {
        this.childContentLoadError = ''
        for (var j = 0; j < this.nominations[i].length; j++) {
          if (this.nominations[i][j].nomination_event_category[0] !== 19 && this.nominations[i][j].nomination_event_category[0] !== 18 && this.nominations[i][j].nomination_event_category[0] !== 17 && this.nominations[i][j].nomination_event_category[0] !== 100 && this.nominations[i][j].nomination_event_category[0] !== 138 ) {
            if (this.nominations[i][j].nomination_approve_decline[0] === 'Accepted') {
              if (this.checkNominationWorkflow(this.nominations[i][j].teamnominationworkflow[0])) {
                console.log('workflow selected')
                this.reviewdNominations = this.reviewdNominations.concat(this.nominations[i][j])
                console.log(' this.reviewdNominations ', this.reviewdNominations)
              }
            }
          }
        }
      }
      this.showReviewdNominations = true
    },
    loadNominationsforHRBP: function () {
      this.hrbpNominations = []
      for (var i = 0; i < this.nominations.length; i++) {
        this.childContentLoadError = ''
        for (var j = 0; j < this.nominations[i].length; j++) {
          if (this.nominations[i][j].nomination_event_category[0] !== 19 && this.nominations[i][j].nomination_event_category[0] !== 18 && this.nominations[i][j].nomination_event_category[0] !== 17) {
            let temp = (this.nominations[i][j].teamnominationworkflow[0].filter(d => d.project_sponsor_email.toLowerCase() === this.userDetails.email.toLowerCase() && (d.project_sponsor_status === 'Reject' || d.project_sponsor_status === 'Approve') && d.project_sponsor_name.toLowerCase() === 'hrbp'))
            if (temp.length > 0 && (temp[0].project_sponsor_status === 'Reject' || temp[0].project_sponsor_status === 'Approve')) {
              this.hrbpNominations = this.hrbpNominations.concat(this.nominations[i][j])
            }
          }
        }
      }
      if (this.nominations.length > 0) {
        this.showHRBPNominations = true
      }
    },
    checkNominationWorkflow: function (workflow) {
      console.log('profile UD-> ', this.userDetails)    
      let workflowStages = WordpressRestURI.workflowStages
      console.log('checkNominationWorkflow: loadNominationsforReview:  workflowStages ', workflowStages)
      let status = false
      for (var t = 0; t < workflowStages.length; t++) {
        let temp = (workflow.filter(d => d.project_sponsor_status === '' && d.project_sponsor_name.toLowerCase() === workflowStages[t]))
        if (temp.length > 0) {
          console.log('checkNominationWorkflow: loadNominationsforReview: inside if loop temp ', temp, temp.length,temp[0].project_sponsor_name, workflowStages[t], this.userDetails)
          console.log('checkNominationWorkflow: loadNominationsforReview: temp[0].project_sponsor_email.toLowerCase() ', temp[0].project_sponsor_email.toLowerCase(), temp[0].project_sponsor_email.toLowerCase().trim())
          console.log('checkNominationWorkflow: loadNominationsfor, Review: this.userDetails.email.toLowerCase() ', this.userDetails.email.toLowerCase(), this.userDetails.email.toLowerCase().trim())
          if ( (temp[0].project_sponsor_email.toLowerCase().trim() === this.userDetails.email.toLowerCase().trim()) || (temp[0].project_sponsor_email.toLowerCase().trim() === this.userDetails.username.toLowerCase().trim())) {
            status = true
          }
          break
        }
      }
      return status
    }
  }
}
</script>

<style lang="less">
  .nav-link {
    padding: 0.5rem 0.85rem;
  }
  .userProfilePic {
    width: auto;
    height: 150px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .community-categories {
    display: inline;
    a {
      &::after {
        content: ', '
      }
      &:last-child {
        &::after {
          content: ''
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue